// Color Helper

const d3_10color = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
const color_brewer1 = ["#fbb4ae","#b3cde3", "#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec"];
const color_brewer2 = ["#b3e2cd","#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"];
const COLORS: string[] = [
    "#1A7AB1",
    "#ADC8E6",
    "#FF772D",
    "#FFB87F",
    "#2AA13A",
    "#98E090",
    "#FF9398",
    "#9467B9",
    "#C5B0D3",
    "#C49B95",
    "#E474C0",
    "#F7B4D1",
    "#BCBC3D",
    "#07C1CD"
    ]

const color_collection = d3_10color.concat(color_brewer1).concat(color_brewer2).concat(COLORS);

const GREEN: string[] = [
    "#498B77",
    "#89C2AE",
    "#C1D6D3",
    "#20DF20"
]
const BLUE: string[] = [
    "#3E97C7",
    "#72B3CF",
    "#8FCCDD",
    "#C8DADE"

]
const ORANGE: string[] = [
    "#E96206",
    "#F79143",
    "#F6AD76",
    "#F7CEA7"
]
const PINK: string[] = [
    "#F6B1C3",
    "#F07F93",
    "#DE4863",
    "#BC0F46"

]
const RED: string[] = ["#DC143C", "#E64C4C"];
const YELLOW : string[] = ['#fee08b'];
const GRAY: string[] = ['#999999'];
const WHITE: string[] = ["#ffffff"];

const YlGnBu: string[] = [
    "#ffffd9","#edf8b1","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"
]
const BlYlRd: string[] = [
    '#313695',
    '#4575b4',
    '#74add1',
    '#abd9e9',
    '#e0f3f8',
    '#ffffbf',
    '#fee090',
    '#fdae61',
    '#f46d43',
    '#d73027',
    '#a50026'
  ];
const getLineColorMap = () => {
    return BlYlRd;
    // return YlGnBu;
}
const getLineColor = (attribution:number) => {
    let step = attribution;
    if(step <0){
        step = 0;
    }
    if(step>1){
        step = 1;
    }
    let ColorList = getLineColorMap();
    let color = getLinearColor(ColorList, step)
    return color;
}

const getSaliencyColor = (attribution:number) => {
    let step = (attribution + 1 ) / 2;
    if(step <0){
        step = 0;
    }
    if(step>1){
        step = 1;
    }
    let ColorList = [RED[1], WHITE[0], GREEN[3]];
    return getLinearColor(ColorList, step);
}
const getLinearColor = (ColorList: string[], step:number) => {
    let totalColor = ColorList.length;
    let divide = 1/ (totalColor - 1);
    let location = Math.floor(step / divide);
    if(location == totalColor - 1){
        location = location - 1;
    }
    let offset = step - location * divide;
    let adjusted_offset = offset / divide;
    return getGradientColor(ColorList[location], ColorList[location+1], adjusted_offset);
}
const getGradientColor = (startColor : string,endColor :string,step : number) => {
    let colorRgb = (sColor : string)=>{
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        var sColor = sColor.toLowerCase();
        if(sColor && reg.test(sColor)){
            if(sColor.length === 4){
                var sColorNew = "#";
                for(var i=1; i<4; i+=1){
                    sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
                }
                sColor = sColorNew;
            }
            var sColorChange = [];
            for(var i=1; i<7; i+=2){
                sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
            }
            return sColorChange;
        }else{
            return sColor;
        }
    };
    startColor = startColor.replace(/\s+/g,"");
    endColor = endColor.replace(/\s+/g,"");
    let startRGB : any = colorRgb(startColor);//转换为rgb数组模式
    //console.log(startRGB);
    let startR = startRGB[0];
    let startG = startRGB[1];
    let startB = startRGB[2];

    let endRGB : any = colorRgb(endColor);
    //console.log(endRGB);

    let endR = endRGB[0];
    let endG = endRGB[1];
    let endB = endRGB[2];
    if(step>1){
        console.log("out of range step: ", step);
        step = 1;
    }else if(step<0){
        console.log("out of range step: ", step);
        step = 0;
    }
    let sR = (endR-startR)*step;//总差值
    let sG = (endG-startG)*step;
    let sB = (endB-startB)*step;
    var R = parseInt((sR+startR));
    var G = parseInt((sG+startG));
    var B = parseInt((sB+startB));
    var strHex = "#";
    var aColor = new Array();
    aColor[0] = R;
    aColor[1] = G;
    aColor[2] = B;
    for(let j=0; j<3; j++){
        let hex : string = Number(aColor[j]).toString(16);
        let shex : string = Number(aColor[j])<16 ? '0'+hex :hex;
        if(shex === "0"){
            shex += shex;
        }
        strHex += shex;
    }
    return strHex;
}

function hexToRgbA(hex:any, alpha:any){
    var c:any;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+alpha+')';
    }
    console.log("Bad Hex", hex, alpha);
    return 'rgba(0,0,0,1)';
    //throw new Error('Bad Hex');
}
function setsAreEqual(a:any, b:any) {
    if (a.size !== b.size) {
      return false;
    }
  
    return Array.from(a).every(element => {
      return b.has(element);
    });
  }
function arraysEqual(a:any, b:any) {
    if (a === b) return true;
    if (a==null || b==null){
        console.log("one of array is null", a, b);
        return false;
    }
    if (a.length !== b.length) return false;
  
    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.
  
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
// hexToRgbA('#fbafff')
const EChartsColor = [
    "#c23531",
    "#2f4554",
    "#61a0a8",
    "#d48265",
    "#91c7ae",
    "#749f83"
]

const DefaultColor = BLUE[1];
const StartColor = BLUE[0];
const EndColor = RED[0];
const getCoraNodeColor = ( node_label:number,color_encode:number = 2) =>{
    if(color_encode === 1 || color_encode === 2 || color_encode === 3){
        return d3_10color[node_label];
    }else if(color_encode === 5){
        if(node_label){
            return GREEN[0];
        }else{
            return RED[0];
        }
    }
    
}

const getLegendColor = (index:number) => {
    let length = color_collection.length;
    return color_collection[index % length];
}

// Transform Data Helper

// Construct Graph In from Graph obj
function constructGraphIn(graph_obj:any){
    let senders = graph_obj.srcs;
    let receivers = graph_obj.dsts;
    let num_nodes = graph_obj.num_nodes;
    return {
        "senders":senders,
        "receivers":receivers,
        "num_nodes":num_nodes
    }
}


// Construct Neighbor Set from Graph in. 
function constructNeighborSet(graph_in:any){
    // Input: Graph_in
    //   senders:  source of edges.
    //   receivers:   target of edges.
    //   node_num:  number of nodes.
    // Output: 
    //   NeighborSet: Dict[Key] <-- incoming neighbors.
    let senders = graph_in.senders;
    let receivers = graph_in.receivers;
    let node_num = graph_in.num_nodes;
    let NeighborSet:any = {};
    for(let i = 0; i<node_num ;i++){
        NeighborSet[i] = [];
    }
    for(let i = 0; i< receivers.length; i++){
        let nowreceiver = receivers[i];
        if(nowreceiver in NeighborSet){
        }else{
            NeighborSet[nowreceiver] = []
        }
        NeighborSet[nowreceiver].push(senders[i]);
    }
    return NeighborSet;
}
function constructPathDict(message_passing:any){
    let senders = message_passing.senders;
    let receivers = message_passing.receivers;
    let values = message_passing.values;
    let PathDict:any = {};
    for(let i = 0; i< receivers.length; i++){
        let nowreceiver = receivers[i];
        if(nowreceiver in PathDict){
        }else{
            PathDict[nowreceiver] = {}
        }
        PathDict[nowreceiver][senders[i]] = values[i];
    }
    return PathDict;
}
function getTrainColor(node_id:any, train_set:any){
    if(train_set.has(node_id)){
        //return "#fff";
        return "#000";
    }else{
        return "#fff";
    }
}
function getNodeStatisticStr(selectedNodeLength: number, totalNodeLength: number){
    let str : string = "" + selectedNodeLength + "/"+ totalNodeLength;
    let percentage : number ;
    if(totalNodeLength === 0){

    }else{
        percentage = selectedNodeLength / totalNodeLength * 100;
        str = str + " (" + percentage.toFixed(2) +"%)"
    }
    return str;
}


function compareSelectedNodeIdList(list_a:any, list_b:any){
    if(list_a.length === list_b.length){
        for(let i = 0; i<list_a.length; i++){
            if(list_a[i] === list_b[i]){

            }else{
                return false;
            }
        }
        return true;
    }else{
        return false;
    }
}

function get_boundingbox(graph_layout:any[]){
    if(graph_layout.length === 0){
        return {
            "xmin":0,
            "xmax":0,
            "ymin":0,
            "ymax":0
        }
    }else{
        let xmin = graph_layout[0][0];
        let xmax = graph_layout[0][0];
        let ymin = graph_layout[0][1];
        let ymax = graph_layout[0][1];
        for(let i = 0; i< graph_layout.length; i++){
            let nowx = graph_layout[i][0];
            let nowy = graph_layout[i][1];
            if(xmin > nowx){
                xmin = nowx;
            }
            if(xmax < nowx){
                xmax = nowx;
            }
            if(ymin > nowy){
                ymin = nowy;
            }
            if(ymax < nowy){
                ymax = nowy;
            }
        }
        return {
            "xmin":xmin,
            "xmax":xmax,
            "ymin":ymin,
            "ymax":ymax
        }
    }
}
function transform_graphlayout(graph_layout:any[], width:number, height:number){
    if(graph_layout.length === 0){
        return graph_layout;
    }else{
        let bounding_box = get_boundingbox(graph_layout);
        //let canvas_centerx = 300;
        //let canvas_centery = 300;
        //let width = Swidth;
        //let height = Sheight;
        let margin = 20;
        if(graph_layout.length >= 100){
            margin = 20;
        }
        
        let realwidth = width - 2*margin;
        let realheight = height - 2*margin;
        let gap_x = bounding_box["xmax"] - bounding_box["xmin"];
        let gap_y = bounding_box["ymax"] - bounding_box["ymin"];
        if(gap_x === 0){
            gap_x = 1e-16;
        }
        if(gap_y === 0){
            gap_y = 1e-16;
        }
        let realscale = Math.min(realwidth / gap_x, realheight / gap_y);
        let left = margin + (realwidth - realscale * gap_x) / 2;
        let top = margin + (realheight - realscale * gap_y) / 2; 
        let xmin = bounding_box["xmin"];
        let ymin = bounding_box["ymin"];
        let new_graph_layout = [];
        for(let i = 0; i< graph_layout.length; i++){
            let nowx = graph_layout[i][0];
            let nowy = graph_layout[i][1];
            let locx = left+ (nowx - xmin) * realscale;
            let locy = top + (nowy - ymin) * realscale;
            new_graph_layout.push([locx,locy]);
        }
        return new_graph_layout;
    }
}
function skew_weight(weight:any, range_min:any=0.1, range_max:any=1){
    // Assume weight is [0,1]
    return (weight - 0) * 0.9 + range_min;
}

function assert_key(pkg:any, key_list:any, verbose:boolean=false, pkg_name:any = ""){
    let flag = true;
    let pkg_key_list = Object.keys(pkg);
    for(let i = 0; i<key_list.length; i++){
        if(pkg_key_list.indexOf(key_list[i]) >= 0){

        }else{
            flag =  false;
            if(verbose){
                
                let message = ""+key_list[i]+" is required.";
                if(pkg_name){
                    message = ""+key_list[i]+" is required in " + pkg_name +" .";
                }
                console.log(message);
            }
        }
    }
    return flag;
}
function assert_key_hier(pkg:any, key_hier_list:any, verbose:boolean=true, pkg_name:any = ""){
    let filtered_key_hier_list = key_hier_list.filter((d:any)=>{
        return Object.keys(d).indexOf("n")>=0;
    });
    let first_level_key_list = filtered_key_hier_list.map((d:any)=>{
        return d["n"];
    });
    let first_key_flag = assert_key(pkg, first_level_key_list, verbose, pkg_name);
    if(first_key_flag){
        let flag = true;
        for(let i = 0; i<filtered_key_hier_list.length; i++){
            let name = filtered_key_hier_list[i]["n"];
            if(Object.keys(filtered_key_hier_list[i]).indexOf("c")>=0){
                let children = filtered_key_hier_list[i]["c"];
                let local_flag = assert_key_hier(pkg[name], children, verbose, pkg_name+"."+name);
                if(!local_flag){
                    flag = false;
                }
            }
        }
        return flag;
    }
    return false;
    
}
function removeAllChildNodes(parent:any) {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}
// Get text width before rendering
const getTextWidth = (text:any, font:any) => {
    const element = document.createElement('canvas');
    const context:any = element.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
}

// meta text mode

const MODE_OPTIONS = ["Metrics", "Explore"];
function get_mode_options(){
    return MODE_OPTIONS;
}
function safe_extract_item_from_list(id:any, items:any, default_ret:any=""){
    let selected_name:any = default_ret;
    if(id){
        let index = id - 1;
        if(index >= 0 && index < items.length){
            selected_name = items[index];
        }
    }
    return selected_name;
}
function safe_extract_items_from_list(id_list:any, items:any, default_ret:any=[]){
    let selected_name_list:any = default_ret;
    if(id_list){
        id_list.forEach((d:any)=>{
            let selected_name = safe_extract_item_from_list(d, items);
            if(selected_name){
                selected_name_list.push(selected_name);
            }else{
                console.log("WARNING: some data are not found.", d);
            }
        })
    }
    return selected_name_list;
}

function addRange(a:any,b:any){
    if(a["active"]){
        if(a["end"]<b["start"]){
            return {
                "active":true,
                "start":a["start"],
                "end":b["end"],
                "count":a["count"]+b["count"]
            }
        }else{
            console.log("invalid added");
            return {
                "active":false
            }
        }
        
    }else{
        if(b["active"]){
            return b;
        }else{
            console.log("inactive added");
            return {
                "active":false
            }
        }
    }
}
function binningContinuousVariable(continuous_variable_list:any, bucket_num:number=8){
    let nodenum = continuous_variable_list.length;
    let distribution:any = {};
    for(let i = 0; i<nodenum; i++){
        if(distribution[continuous_variable_list[i]]){
            distribution[continuous_variable_list[i]] = distribution[continuous_variable_list[i]]+1;

        }else{
            distribution[continuous_variable_list[i]] = 1;
        }
    }
    let key:any = Object.keys(distribution);
    let new_key:any = [];
    for(let i = 0; i<key.length; i++){
        new_key.push(parseFloat(key[i]));
    }
    let compare_number = (a:number, b:number)=>{
        return a-b;
    }
    new_key = new_key.sort(compare_number);
    //console.log(new_degree_key);
    let range_list = [];
    let prev_range = {
        "active":false
    }
    let current_range:any = {
        "active":false
    }

    let single_bucket_count = nodenum / bucket_num;
    for(let i = 0; i<new_key.length; i++){
        let this_range = {
            "active":true,
            "start":new_key[i],
            "end":new_key[i],
            "count":distribution[new_key[i]]
        }
        
        current_range = addRange(prev_range, this_range);
        //console.log(i, prev_range, this_range, current_range);
        // Assume result range is active
        if(current_range["active"]){
            if(current_range["count"]<single_bucket_count){
                if(i === key.length-1){
                    range_list.push(current_range);
                    current_range = {
                        "active":false
                    }
                }
            }else if(current_range["count"]>=2*single_bucket_count){
                if(prev_range["active"]){
                    range_list.push(prev_range);
                }
                range_list.push(this_range);
                current_range = {
                    "active":false
                }
            }else{
                range_list.push(current_range);
                current_range = {
                    "active":false
                }
            }
            prev_range = Object.assign({}, current_range);
        }
    }
    for(let i = 0; i<range_list.length; i++){
        let start = range_list[i]["start"];
        let end = range_list[i]["end"];
        if(start === end){
            range_list[i]["name"] = ""+end;
        }else{
            range_list[i]["name"] = "["+start.toFixed(2)+","+end.toFixed(2)+"]";
        }
    }
    return range_list;
}

function getContinuousVariableCategory(value:number, value_list:any){
    for(let i = 0; i<value_list.length; i++){
        let start = value_list[i]["start"];
        let end = value_list[i]["end"];
        //console.log(degree, start, end);
        if(value>=start && value<=end){
            return value_list[i]["name"];
        }
    }
    return ""+value;
}
////////////////////////////


// System Overview Config
enum SystemDesign{
    FULL = 1,
    EXCLUEDE_INSTANCE_VIEW = 2
}

const DECIMAL = 2;
let layout_config_version:any = {
    "System": SystemDesign.FULL
}
function getLayoutConfig(name:any="System"){
    if(Object.keys(layout_config_version).indexOf(name)>=0){
        return layout_config_version[name];
    }else{
        return layout_config_version["System"];
    }
}

function getDecimal(){
    return DECIMAL;
}




export { RED,YELLOW, EChartsColor,  getSaliencyColor, getLineColor, getCoraNodeColor, constructNeighborSet,  constructPathDict,getTrainColor, 
     compareSelectedNodeIdList,getNodeStatisticStr,
     constructGraphIn,transform_graphlayout,skew_weight,
      assert_key, assert_key_hier, getLayoutConfig, 
      removeAllChildNodes,getTextWidth,getLegendColor,hexToRgbA,
    SystemDesign, getLineColorMap, arraysEqual, setsAreEqual, get_mode_options, 
    safe_extract_item_from_list, safe_extract_items_from_list,
    binningContinuousVariable, getContinuousVariableCategory, getDecimal}
